import type { ReactNode } from "react";
import { cx } from "../../lib/cx";

/**
 * A section heading with an optional right-aligned meta ("3 de 5", a date).
 * A2's `SectionTitle`. The meta is `tabular-nums`, because it is usually a
 * count that changes.
 */

export interface SectionTitleProps {
  /** The heading level; `h2` unless the section sits under another h2. */
  as?: "h2" | "h3";
  className?: string;
  meta?: ReactNode;
  title: string;
}

export function SectionTitle({
  title,
  meta,
  as,
  className,
}: SectionTitleProps) {
  const Heading = as ?? "h2";
  return (
    <div className={cx("flex items-baseline justify-between gap-3", className)}>
      <Heading className="font-semibold text-ink text-lg">{title}</Heading>
      {meta ? (
        <span className="text-right text-ink-3 text-sm tabular-nums">
          {meta}
        </span>
      ) : null}
    </div>
  );
}
